<div class="form-group form-input-group" *ngIf="items.length">
  <label class="form-input-label" *ngIf="label">{{label}}</label>
  <div class="badge-list">
    <span class="badge badge-pill badge-light" *ngFor="let item of items">
      {{item.label}}
      <a href="javascript:;" (click)="removeItem(item.id)" *ngIf="item.canRemove">&times;</a>
    </span>
  </div>
</div>
